/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListScheduleResponse {
    getFixupPrototypeFunction() { return ListScheduleResponse.fixupPrototype; }

    static newInstance(model: Partial<ListScheduleResponse>): ListScheduleResponse {
        let obj = Object.assign(new ListScheduleResponse(), model);
        ListScheduleResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListScheduleResponse>): ListScheduleResponse {
        if (!model) return null;
        return ListScheduleResponse.newInstance(<ListScheduleResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListScheduleResponse) {
        if (!obj) return;

        models.ListScheduleResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListScheduleResponse): boolean {
        Object.setPrototypeOf(obj, ListScheduleResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.schedules) {
            for (let val of this.schedules) {
                models.ScheduleData.fixupPrototype(val);
            }
        }
    }

    /**
     * Page count
     */
    page_count: number;

    /**
     * Total count
     */
    total_count: number;

    /**
     * Schedule Details
     */
    schedules: Array<models.ScheduleData>;

}
